export function domReady(fn) {
  if (
    document.readyState === "interactive" ||
    document.readyState === "complete"
  ) {
    return fn()
  }

  document.addEventListener("DOMContentLoaded", fn, false)
}

export function init(activeModules) {
  Object.keys(activeModules).forEach((moduleName) => {
    if (!!activeModules[moduleName].init) {
      activeModules[moduleName].init()
    }
  })
}

/**
 * A simple Redux-like state management implementation
 *
 * @param {function} reducer The custom reducer.
 * @returns {function} unsubscribe Remove listener.
 */
export function createStore(reducer) {
  let listeners = []
  let currentState = reducer(undefined, {})

  return {
    getState: () => currentState,
    dispatch: (action) => {
      currentState = reducer(currentState, action)

      listeners.forEach((listener) => {
        listener()
      })
    },
    subscribe: (newListener) => {
      listeners.push(newListener)

      const unsubscribe = () => {
        listeners = listeners.filter((l) => l !== newListener)
      }

      return unsubscribe
    },
  }
}

export function getCookie(name) {
  var nameEQ = name + "="
  var ca = document.cookie.split(";")
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == " ") c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

export function setCookie(name, value, options = {}) {
  options = {
    path: "/",
    ...options,
  }

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString()
  }

  let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value)

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey
    let optionValue = options[optionKey]
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue
    }
  }

  document.cookie = updatedCookie
}

export function getScrollbarWidth() {
  const outer = document.createElement('div')
  outer.style.visibility = 'hidden'
  outer.style.overflow = 'scroll'
  outer.style.msOverflowStyle = 'scrollbar'
  document.body.appendChild(outer)

  const inner = document.createElement('div')
  outer.appendChild(inner)

  const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth)

  outer.parentNode.removeChild(outer)

  return scrollbarWidth
}

// export function loadJSON(file, callback) {
//   const xObj = new XMLHttpRequest()
//   xObj.overrideMimeType("application/json")
//   xObj.open("GET", file, true)
//   xObj.onreadystatechange = function () {
//     if (xObj.readyState === 4 && xObj.status === 200) {
//       callback(JSON.parse(xObj.responseText))
//     }
//   }
//   xObj.send(null)
// }

// export function loadAssets(assetsObj) {
//   const getAssetObj = (manifest, id, deps) => {
//     return {
//       [id]: {
//         id,
//         url: id.includes("https://") ? id : manifest[id],
//         deps,
//       },
//     }
//   }

//   const withDeps = (manifest, type = "css") => {
//     const asset = assetsObj[type]

//     return {
//       ...getAssetObj(manifest, asset["id"], asset.deps),
//       ...(Array.isArray(asset.deps) && asset.deps.length > 0
//         ? asset.deps.reduce(
//             (prev, dep) => ({
//               ...prev,
//               ...getAssetObj(manifest, dep),
//             }),
//             {},
//           )
//         : {}),
//     }
//   }

//   return new Promise((resolve, reject) => {
//     const loadJs = (manifest) => {
//       if (!!assetsObj["js"]) {
//         new loadAsset({
//           moduleName: assetsObj["js"].id,
//           assets: withDeps(manifest, "js"),
//           type: "js",
//         }).then(resolve)
//       } else {
//         resolve()
//       }
//     }

//     loadJSON(`${themeVars.templateUri}/assets/dist/manifest.json`, (manifest) => {
//       if (!!assetsObj["css"]) {
//         new loadAsset({
//           moduleName: assetsObj["css"].id,
//           assets: withDeps(manifest),
//         }).then(loadJs.bind(null, manifest))
//       } else {
//         loadJs(manifest)
//       }
//     })
//   })
// }
